import API from '../apiClient';

export const getPlatformHealth = () => API.get('/platform/health');

export const getSignupSummary = (params = {}) =>
  API.get('/platform/signups/summary', { params });

export const getSignupTimeseries = (params = {}) =>
  API.get('/platform/signups/timeseries', { params });

export const getUserActivity = () => API.get('/platform/users/activity');

export const getExpiringSubscriptions = (params = {}) => {
  const query = typeof params === 'number' ? { within_days: params } : params;
  return API.get('/platform/subscriptions/expiring', { params: query });
};

export const getPlatformOrgs = (params = {}) =>
  API.get('/platform/orgs', { params });

export const getPlatformAudit = (params = {}) =>
  API.get('/platform/audit', { params });

// ---- Knowledge Base in Trust Center (Zavior-Admin-only gate) ----

export const updateOrgKnowledgeBaseTrustCenterEnabled = (orgId, enabled) =>
  API.put(`/platform/orgs/${orgId}/knowledge-base-trust-center-enabled`, { enabled });

export const updateOrgZavvyFocusEnabled = (orgId, enabled) =>
  API.put(`/platform/orgs/${orgId}/zavvy-focus-enabled`, { enabled });

// ---- Trust Center sharing & custom links tracker ----

export const getTrustCenterOrgs = (params = {}) =>
  API.get('/platform/orgs/trust-center', { params });

export const revokeOrgTrustCenterPublicLink = (orgId) =>
  API.post(`/platform/orgs/${orgId}/trust-center/revoke-public-link`);

export const updateOrgTrustCenterPortalEnabled = (orgId, enabled) =>
  API.put(`/platform/orgs/${orgId}/trust-center/portal-enabled`, { enabled });

export const resetOrgTrustCenterHostname = (orgId) =>
  API.post(`/platform/orgs/${orgId}/trust-center/reset-hostname`);

// ---- Knowledge Base Domain Sources (Trinity-only Policy/Control picker for
// the 6 narrative-only card_keys — encryption, logging-monitoring,
// incident-response, business-continuity, access-control,
// personal-data-practices — see Part 9 of the IP Trust Center Sections +
// Gating plan) ----

export const getOrgKnowledgeBaseDomainSources = (orgId) =>
  API.get(`/platform/orgs/${orgId}/knowledge-base-domain-sources`);

export const updateOrgKnowledgeBaseDomainSources = (orgId, cardKey, sources) =>
  API.put(`/platform/orgs/${orgId}/knowledge-base-domain-sources`, { card_key: cardKey, sources });

export const getAuthSettings = () => API.get('/platform/auth-settings');

export const updateAuthSettings = (payload) => API.put('/platform/auth-settings', payload);
